(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    var accordions = document.querySelectorAll('.accordion--auto-open-description');

    accordions.forEach(function (accordion) {
      var detailsList = accordion.querySelectorAll('details');

      detailsList.forEach(function (details) {
        var summary = details.querySelector('summary, .details__header');
        if (!summary) return;

        var headingText = summary.textContent.trim().toLowerCase();
        if (headingText.includes('description')) {
          details.setAttribute('open', '');
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
